import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DramaMaskIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#drama-mask__a)",
                            children: [
                                _jsx("path", {
                                    d: "M3.675 15.37c-.3 0-.59-.13-.79-.38a10.464 10.464 0 01-2.23-6.44v-5.2c0-.37.21-.72.54-.89 4.63-2.39 10.41-2.39 15.04.01.49.25.68.86.43 1.35-.25.49-.85.68-1.35.43-3.88-2.01-8.7-2.11-12.66-.27v4.57c0 1.88.64 3.73 1.81 5.21.34.43.27 1.06-.17 1.4-.18.14-.4.21-.62.21z"
                                }),
                                _jsx("path", {
                                    d: "M12.465 23.33c-.38 0-.77-.05-1.14-.14-.7-.18-1.36-.53-1.91-1.01-1.62-1.4-2.83-3.23-3.48-5.28-.65-2.05-.71-4.24-.19-6.33l1.16-4.65c.09-.36.37-.64.72-.73 2.68-.68 5.51-.68 8.18-.01 2.68.67 5.17 2.01 7.21 3.87.27.25.39.63.3.98l-1.16 4.63c-.51 2.09-1.59 3.99-3.12 5.5a11.577 11.577 0 01-5.55 3.05c-.33.08-.68.11-1.02.11v.01zM8.705 7l-1.01 4.06c-.44 1.73-.38 3.54.16 5.24.54 1.7 1.54 3.21 2.89 4.38a2.623 2.623 0 002.31.6c1.74-.4 3.32-1.27 4.59-2.52a9.657 9.657 0 002.59-4.56l1.02-4.05a14.742 14.742 0 00-5.9-3.02c-2.17-.54-4.45-.58-6.63-.12L8.705 7z"
                                }),
                                _jsx("path", {
                                    d: "M12.545 12.87c-.43 0-.83-.28-.96-.72a.633.633 0 00-.16-.26.72.72 0 00-.27-.15.797.797 0 00-.37-.02c-.1.03-.2.08-.27.16-.38.4-1.01.42-1.41.03a.987.987 0 01-.03-1.41c.33-.34.74-.59 1.2-.71.46-.12.94-.12 1.39.01.4.09.81.31 1.14.63.33.31.58.71.7 1.15a.996.996 0 01-.95 1.28l-.01.01zm6.26 1.59c-.44 0-.85-.3-.97-.75-.03-.1-.08-.2-.16-.27a.605.605 0 00-.27-.15.692.692 0 00-.32 0c-.1.03-.19.09-.26.16a.988.988 0 01-1.41.05.997.997 0 01-.05-1.41c.32-.34.72-.59 1.16-.72.45-.13.92-.14 1.37-.03.45.11.86.35 1.19.67.33.33.57.74.68 1.19.14.53-.18 1.08-.71 1.22-.08.02-.17.03-.25.03v.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "drama-mask__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
DramaMaskIcon.isCarinaIcon = true;
export default DramaMaskIcon;
